import gql from 'graphql-tag'

export const QUERY_REFRESH = gql`
  query refreshToken {
    refreshToken
  }
`

export const QUERY_SINGLE_LOGIN = gql`
  query loginWithAuthCode($authCode: String!) {
    loginWithAuthCode(authCode: $authCode) {
      user {
        _id
        name
        login
        pages
        multi_user
        mf
        admin
        profiles
        email_confirmed
        ecommerce
        club
        has_pii_access
        has_pii_employees_access
        ecommercePermissions
        account {
          _id
          name
          franchise_id
          id_external
          modules
          is_franchise
          is_franchisee
          only_mercapromo
          has_mercapromo
          channels {
            ecommerce_v2 {
              active
              integration {
                url
              }
            }
          }
        }
      }
      session_id
    }
  }
`

export const QUERY_CHECK_AVAILABLE_EMAIL = gql`
  query internalUserEmailIsAvailable($email: String!) {
    internalUserEmailIsAvailable(email: $email)
  }
`
